/**
 * Cadena OFIMA + recaudo para Plan Separe tras verificación de abonos (no usar en crear/editar pedido).
 */
import axiosInstance from '../../api/axiosInstance'
import ofimaSyncService from '../../api/ofimaSyncService'
import { facturarRemision } from './ofimaRemisionFacturaService'

type PedidoEjecutarYConsultar = {
  Numero?: string
  NumeroOfima?: string | number
  Procesado?: boolean | number | string
  Mensaje?: string
}

const MSJ_SIN_REMISION_PLAN_SEPARE =
  'No se encontró remisión en OFIMA para el pedido Plan Separe'

/** Cuando ejecutar-y-consultar responde 200 pero sin remisión usable (p. ej. Procesado false + Mensaje). */
function mensajeSinRemisionTrasEjecutarYConsultar(
  _orderId: string,
  pedidoMatch: PedidoEjecutarYConsultar | null | undefined
): string {
  const detalle =
    pedidoMatch && typeof pedidoMatch.Mensaje === 'string'
      ? pedidoMatch.Mensaje.trim()
      : ''
  if (detalle) {
    return `${MSJ_SIN_REMISION_PLAN_SEPARE} ("${detalle}")`
  }
  return MSJ_SIN_REMISION_PLAN_SEPARE
}

export async function runOfimaChainBeforeFirstCierre(
  orderId: string,
  storeName: string
): Promise<{ nrodcto: string }> {
  await ofimaSyncService.sendToOfima([orderId])
  await ofimaSyncService.ejecutarSPX()
  const consulta = await ofimaSyncService.ejecutarYConsultar([orderId])
  const pedidoOfima = Array.isArray(consulta?.pedidos)
    ? consulta.pedidos.find(
        (p: PedidoEjecutarYConsultar) => String(p.Numero) === orderId
      )
    : null
  const nrodcto = pedidoOfima?.NumeroOfima ? String(pedidoOfima.NumeroOfima).trim() : ''
  if (!nrodcto) {
    throw new Error(mensajeSinRemisionTrasEjecutarYConsultar(orderId, pedidoOfima))
  }
  await facturarRemision('RE', nrodcto, {
    tipoFactura: 'FS',
    sglOrderId: orderId,
    idMarket: storeName || '',
    numeroPedido: orderId
  })
  return { nrodcto }
}

export interface RecaudoCierreAbonoBody {
  orderId: string
  paymentMethod: string
  nrodcto: string
  tipodcto: string
  abono: {
    valor: number
    metodo_pago: string
    id_transaccion: string | null
    id_pedido_pago?: number | null
  }
}

type RecaudoCierreResponse = {
  status?: string
  code?: string
  message?: string
  error?: string
  data?: {
    status?: string
    code?: string
    message?: string
    error?: string
  }
}

const NEGATIVE_STATUSES = ['error', 'failed', 'failure', 'rejected', 'not_applied', 'negative']

export async function postRecaudoCierre(body: RecaudoCierreAbonoBody): Promise<void> {
  const response = await axiosInstance.post('/ofima-sync/recaudos/cierre', body)
  const payload = (response?.data || {}) as RecaudoCierreResponse
  const status = (payload.status || payload.data?.status || '').toString().trim().toLowerCase()
  const code = (payload.code || payload.data?.code || '').toString().trim()
  const apiMessage =
    payload.message ||
    payload.data?.message ||
    payload.error ||
    payload.data?.error ||
    ''

  if (NEGATIVE_STATUSES.includes(status)) {
    throw new Error(apiMessage || 'No se pudo aplicar el abono (status negativo en /recaudos/cierre)')
  }

  if (code !== 'RECAUDO_APPLIED') {
    throw new Error(
      apiMessage ||
        `No se pudo aplicar el abono: respuesta inválida de /recaudos/cierre (code: ${code || 'sin código'})`
    )
  }
}
